export default "__VITE_ASSET__Dz68IVLP__";